<div class="h-dvh flex flex-col w-screen">
  <nav class="flex justify-between bg-black text-white p-1.5">
    <div class="flex">
      @if (!permissionIsLoading && !examStudentDashboard) {
      <button mat-icon-button (click)="onToggleOpen()" aria-label="Side Menu">
        <mat-icon class="navIcons" fontIcon="menu"></mat-icon>
      </button>
      }
      @if (examStudentDashboard) {
      <button (click)="dashboardClick()" class="ml-6">
        <img alt="Banner Image" [src]="localStorage.getItem('bannerUrl')" height="45" width="151" />
      </button>
      }
      @if (!examStudentDashboard) {
      <img alt="Banner Image" [src]="localStorage.getItem('bannerUrl')" class="ml-6" height="45" width="151" />
      }
    </div>
    <div class="flex flex-row items-center">
      <div class="flex">
        @if (showSwitchButton) {
        <dropdown-menu [menuItems]="dashboardSwitchMenuItems" text="Dashboard Switcher" [icon]="faChevronDown" />
        }
      </div>
      @if (firstName != null && lastName != null && profile_pic == null) {
      <button (click)="profile()"
        class="bg-gray-200 text-gray-400 rounded-full font-bold h-9 w-9 mx-3 flex items-center justify-center">
        {{firstName[0]}} {{lastName[0]}}
      </button>
      }
      @if (profile_pic != null) {
      <button (click)="profile()" aria-label="Profile Button">
        <img alt="Profile Image" [ngSrc]="listOfProfilePics[profile_pic]" height="36" width="36" class="mx-3" />
      </button>
      }
      <p>{{given_name}}</p>
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Profile Menu">
        <mat-icon class="navIcons" fontIcon="expand_more" role="menu"></mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="profile()">
          Profile
        </button>
        @if (showContentExplorer) {
        <button mat-menu-item (click)="contentExplorer()">
          Content Explorer
        </button>
        }
        <button mat-menu-item (click)="logout()">
          Logout
        </button>
      </mat-menu>
    </div>
  </nav>
  <mat-sidenav-container class="h-screen" autosize>
    <!-- TODO need sideNavButtons for student classroom dashboard -->
    @if (!examStudentDashboard) {
    <mat-sidenav role="menubar" #sidenav mode="over" opened="false" class="bg-slate-100">
      <div class="flex-grow border border-gray-200"></div>
      <div class="w-full p-2 flex flex-col">
        <!-- IMPORTANT this button is because of a bug with mat-sidenav -->
        @for (button of sideNavButtons; track button; let i = $index) {
        <div>
          <button (click)="button.clickAction(i)" [style]="button.mobileStyle()">
            <fa-icon [icon]="button.icon" />
            <p class="text-sm ml-2">{{button.name}}</p>
          </button>
        </div>
        }
      </div>
    </mat-sidenav>
    }
    @if (!permissionIsLoading) {
    <div class="flex flex-row h-full">
      @if (!examStudentDashboard) {
      <div
        [ngClass]="isOpened? 'bg-[#F6F7F8] p-4 flex flex-col fixed h-screen w-[200px]' : 'bg-slate-100 p-4 flex flex-col fixed h-screen'">
        @for (button of sideNavButtons; track button; let i = $index) {
        <div>
          <button (click)="button.clickAction(i)" [tooltip]="isOpened? '' : button.name" tooltipPosition="right"
            [style]="button.style()" [attr.aria-label]="button.name">
            <div [ngClass]="isOpened? 'grid grid-cols-5 gap-3' : 'flex flex-row justify-center'">
              <fa-icon [icon]="button.icon" />
              @if (isOpened) {
              <p class="col-span-4 text-sm text-left">{{button.name}}</p>
              }
            </div>
          </button>
        </div>
        }
      </div>
      }
      @if (!examStudentDashboard || examStudentClassroomDashboard) {
      <div [ngClass]="isOpened? 'w-full ml-[200px]' : 'w-full ml-[68px]'">
        <router-outlet></router-outlet>
      </div>
      }
      @if (examStudentDashboard && !examStudentClassroomDashboard) {
      <div class="w-full">
        <router-outlet></router-outlet>
      </div>
      }
      <!--
        <div *ngIf="!examStudentDashboard" class="absolute bottom-0 ml-7 mb-5">
          <button class="text-slate-400" (click)="router.navigate(['dashboard/Guides']);">
            <fa-icon [icon]="faFileCircleQuestion" />
          </button>
        </div>
        -->
    </div>
    }
    @if (!examStudentDashboard) {
    <div class="fixed bottom-0 ml-7 mb-5">
      <button class="text-slate-400" (click)="router.navigate(['dashboard/Guides']);" aria-label="Guides">
        <fa-icon [icon]="faFileCircleQuestion" />
      </button>
    </div>
    }
  </mat-sidenav-container>
</div>
